import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  createFilterOptions,
  useTheme,
} from "@mui/material";
import TableContent from "../../table/table";
import Namemanage from "../../popups/managename/managename";
import NameJob from "../../popups/jobname/jobname";
import dayjs from "dayjs";

import fileDownload from "js-file-download";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useReactToPrint } from "react-to-print";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useDispatch, useSelector } from "react-redux";
import { GetAllJopTitleAction } from "../../../../redux/actions/JopTitleAction";
import { GetAllDepartmentAction } from "../../../../redux/actions/DepartmentAction";
import {
  CreateEmployeeAction,
  DeleteEmployeeAction,
  GetAllEmployeeAction,
  UpdateEmployeeAction,
} from "../../../../redux/actions/employeeActions";
import notify from "../../../Notifcation";
import axios from "axios";
import Pagination from "../../../Utility/Pagination/Pagination";
import { ToastContainer } from "react-toastify";
import FormPrintView from "../../../Utility/FormPrintView/FormPrintView";
import {
  formatDisplayTime,
  formatPrintTime,
  formatPrintValue,
  getRoleLabel,
} from "../../../Utility/FormPrintView/formPrintHelpers";
const filter = createFilterOptions();
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const namess = [
  "الأحد",
  "الأثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];

function getStyles(name, WorkingDays, theme) {
  return {
    fontWeight:
      WorkingDays.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const Enter = ({ userData }) => {
  const [Search, setSearch] = useState("");
  const [Name, setName] = useState("");
  const [DepartmentId, setDepartmentId] = useState("");
  const [JopName, setJopName] = useState("");
  const [Roles, setRoles] = useState("");
  const [Phone, setPhone] = useState("");

  const [showManage, setshowManage] = useState(false);
  const [showNameJop, setshowNameJop] = useState(false);
  const [Filee, setFilee] = useState([]);
  const [FileeBase64, setBase64] = useState("");
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const [JopType, setJopType] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const theme = useTheme();
  const [WorkingDays, setWorkingDays] = React.useState([]);
  const [DeleteFileNames, setDeleteFileNames] = useState([]);
  const [Presence, setPresence] = useState("");
  const [Salary, setSalary] = useState("");
  const [Tax, setTax] = useState("");
  const [Insurance, setInsurance] = useState("");
  const [Active, setActive] = useState(true);
  const [EmployeeId, setEmployeeId] = useState("");
  const myDivRefWorkcom = useRef();
  const { tableRef, onDownload } = useTableExcelExport(
    "إدارة الموظفين",
    "إدارة الموظفين",
  );

  const [Departure, setDeparture] = useState("");
  const [Note, setNote] = useState("");
  const ALLNameJop = useSelector((state) => state.JopTitleR.GetJopTitle);
  const ALLDepartment = useSelector((state) => state.DepartmentR.GetDepartment);
  const All = useSelector((state) => state.EmployeeR.GetEmployee);
  const PageSize = 7;
  const dispatch = useDispatch();
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setWorkingDays(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  useEffect(() => {
    dispatch(GetAllJopTitleAction());
    dispatch(GetAllDepartmentAction());
  }, []);
  useEffect(() => {
    dispatch(GetAllEmployeeAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };
  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(
      GetAllEmployeeAction(`PageNumber=${page}&PageSize=${PageSize}`),
    );
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setEmployeeId(itemid);
  };

  const handleCloseManage = () => {
    dispatch(GetAllDepartmentAction());

    setshowManage(false);
  };
  const handleShowManage = () => setshowManage(true);

  const handleCloseNameJop = () => {
    dispatch(GetAllJopTitleAction());
    setshowNameJop(false);
  };
  const handleShowNameJop = () => setshowNameJop(true);
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteEmployeeAction(EmployeeId));
    setLoading(false);

    setshowDelete(false);
    setIsPress(false);
  };
  const handlePrint = useReactToPrint({
    contentRef: myDivRefWorkcom,
    documentTitle: "بيانات الموظف",
  });

  // const PresenceTime = dayjs(Presence).format("hh:mm:ss A");

  // const DepartureTime = dayjs(Departure).format("hh:mm:ss A");

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "true";
    if (userData.usedSize >= userData.subscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn",
      );
      return;
    }
    input.onchange = (e) => {
      const files = Array.from(e.target.files); // Convert FileList to an array
      setFilee(files); // Update Filee state with files array

      const base64Array = [];

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          base64Array.push(reader.result); // Add Base64 string to array
          if (base64Array.length === files.length) {
            setBase64(base64Array); // Update Base64 state once all files are processed
          }
        };
        reader.readAsDataURL(file); // Read file as Base64
      });
    };

    // }

    input.click();
  }
  const deleteFile = (index) => {
    const fileToDelete = Filee[index]; // Get the file object
    const fileNameToDelete = fileToDelete?.name || fileToDelete?.fileName; // Get name safely

    // Update files list
    const updatedFiles = Filee.filter((_, idx) => idx !== index);
    setFilee(updatedFiles);

    // Update base64 list
    if (Array.isArray(FileeBase64)) {
      const updatedBase64 = FileeBase64.filter((_, idx) => idx !== index);
      setBase64(updatedBase64);
    } else {
      setBase64("");
    }

    // Append file name to DeleteFileNames
    if (fileNameToDelete) {
      setDeleteFileNames((prev) => [...prev, fileNameToDelete]);
    }
  };

  // const converterqoma = (msg) => {
  //   if (msg !== null) {
  //     let parts = msg.split(",");
  //     return parts;
  //   }
  // };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Name === "" ||
      DepartmentId === "" ||
      JopName === "" ||
      Phone === "" ||
      passwordInput === "" ||
      passwordconfirmInput === "" ||
      WorkingDays.length < 0 ||
      // Presence === "" ||
      // Departure === "" ||
      //  JopType === "" ||
      Salary === "" ||
      Roles === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (JopType === "بالشهر") {
      if (Insurance === "" || Tax === "") {
        notify("من فضلك اكمل البيانات المطلوبة", "error");
        return;
      }
    }
    if (passwordInput !== passwordconfirmInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    if (Filee && Filee.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 موظفين إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 موظفين إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Name", Name);
    formData.append(
      "DepartmentId",
      DepartmentId != null || DepartmentId !== "" ? DepartmentId.id : "",
    );
    formData.append(
      "JopTitleId",
      JopName != null || JopName !== "" ? JopName.id : "",
    );
    formData.append("RoleId", Roles);
    formData.append("PhoneNumber", Phone);
    formData.append("Password", passwordInput);
    formData.append("WorkingDays", WorkingDays.toString());
    formData.append(
      "Presence",
      Presence ? dayjs(Presence).format("hh:mm:ss") : "",
    );
    formData.append(
      "Departure",
      Departure ? dayjs(Departure).format("hh:mm:ss") : "",
    );
    formData.append("JopType", JopType);
    formData.append("Insurance", Insurance);
    formData.append("Tax", Tax);
    formData.append("Salary", Salary);
    Filee.map((item) => {
      return formData.append("Files", item);
    });
    formData.append("FileDescription", Note);
    formData.append("IsAccountActive", Active);
    await dispatch(CreateEmployeeAction(formData));
    setName("");
    setNote("");
    setDepartmentId("");
    setJopName("");
    setRoles("");
    setPhone("");
    setPasswordInput("");
    setpasswordconfirmInput("");
    setWorkingDays([]);
    setPresence("");
    setDeparture("");
    setJopType("");
    setInsurance("");
    setTax("");
    setSalary("");
    setFilee([]);
    setNote("");
    setActive(true);
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      Name === "" ||
      DepartmentId === "" ||
      JopName === "" ||
      Phone === "" ||
      WorkingDays === "" ||
      Presence === "" ||
      Departure === "" ||
      JopType === "" ||
      Salary === "" ||
      Roles === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (JopType === "بالشهر") {
      if (Insurance === "" || Tax === "") {
        notify("من فضلك اكمل البيانات المطلوبة", "error");
        return;
      }
    }
    if (Filee && Filee.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    // if (
    //   userData.subscriptionType === "User-not-subscriped" &&
    //   All.data &&
    //   All.data.length > 4
    // ) {
    //   notify("غير مسموح بأضافة اكثر من 5 موظفين إشترك للتفعيل ", "error");
    //   return;
    // }
    // if (
    //   userData.subscriptionType === "User-not-subscriped" &&
    //   current > 1 &&
    //   All.data.length > 4
    // ) {
    //   notify("غير مسموح بأضافة اكثر من 5 موظفين إشترك للتفعيل ", "error");
    //   return;
    // }

    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Id", EmployeeId);
    formData.append("Name", Name);
    formData.append(
      "DepartmentId",
      DepartmentId != null || DepartmentId !== "" ? DepartmentId.id : "",
    );
    formData.append(
      "JopTitleId",
      JopName != null || JopName !== "" ? JopName.id : "",
    );
    formData.append("RoleId", Roles);
    formData.append("PhoneNumber", Phone);
    formData.append("NewPassword", passwordInput);
    formData.append("WorkingDays", WorkingDays.toString());
    formData.append(
      "Presence",
      Presence ? dayjs(Presence).format("hh:mm:ss") : "",
    );
    formData.append(
      "Departure",
      Departure ? dayjs(Departure).format("hh:mm:ss") : "",
    );
    formData.append("JopType", JopType);
    formData.append("Insurance", Insurance);
    formData.append("Tax", Tax);
    formData.append("Salary", Salary);
    Filee.map((item) => {
      return formData.append("NewFiles", item);
    });
    DeleteFileNames.map((item) => {
      return formData.append("DeleteFileNames", item);
    });
    formData.append("FileDescription", Note);
    formData.append("IsAccountActive", Active);
    await dispatch(UpdateEmployeeAction(formData));
    setName("");
    setNote("");
    setDepartmentId("");
    setJopName("");
    setRoles("");
    setPhone("");
    setPasswordInput("");
    setpasswordconfirmInput("");
    setWorkingDays([]);
    setPresence("");
    setDeparture("");
    setJopType("");
    setInsurance("");
    setTax("");
    setSalary("");
    setFilee([]);
    setNote("");
    setActive(true);
    setBase64("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };

  const Update = (item) => {
    setEmployeeId(item.id);
    setName(item.name);
    setRoles(
      item.roleName === "Responsible"
        ? 6
        : item.roleName === "Employee"
          ? 5
          : "",
    );
    console.log("🚀 ~ Update ~ item:", item);
    setDepartmentId({
      name: item.department,
      id: item.departmentId,
    });
    setJopName({
      name: item.jopTitle,
      id: item.jopTitleId,
    });
    setWorkingDays(item.workingDays.split(",").map((day) => day));

    setPhone(item.phoneNumber);
    setPresence(dayjs(`1970-01-01T${item.presence}`));
    setDeparture(dayjs(`1970-01-01T${item.departure}`));
    setJopType(item.jopType);
    setInsurance(item.insurance);
    setTax(item.tax);
    setSalary(item.salary);
    setFilee(item.userFiles);
    // setNote(item.fileDescription);
    setActive(item.isAccountActive);
    // setFilee([item.userFiles]);
    setNote(item.userFiles[0]?.fileDescription || "");

    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setEmployeeId(item.id);
    setName(item.name);
    setRoles(
      item.roleName === "Responsible"
        ? 6
        : item.roleName === "Employee"
          ? 5
          : "",
    );
    setNote(item.fileDescription === null ? "" : item.fileDescription);
    setDepartmentId({
      name: item.department,
      id: item.departmentId,
    });
    setJopName({
      name: item.jopTitle,
      id: item.jopTitleId,
    });
    setWorkingDays(item.workingDays.split(",").map((day) => day));

    setPhone(item.phoneNumber);
    setPresence(dayjs(`1970-01-01T${item.presence}`));
    setDeparture(dayjs(`1970-01-01T${item.departure}`));
    setJopType(item.jopType);
    setInsurance(item.insurance);
    setTax(item.tax);
    setSalary(item.salary);
    setFilee(item.userFiles);
    setActive(item.isAccountActive);
    // setFilee([item.userFiles]);
    setIsEdit(false);
    setEye(true);
  };

  const res = useSelector((state) => state.EmployeeR.AddEmployee);
  const UP = useSelector((state) => state.EmployeeR.UpdateEmployee);
  const DEL = useSelector((state) => state.EmployeeR.DeleteEmployee);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage === "Great, Employee added successfully"
          ) {
            dispatch(GetAllEmployeeAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          }
          if (
            res.data &&
            res.data.responseMessage === "This phone number is already exist"
          ) {
            dispatch(GetAllEmployeeAction(`PageSize=${PageSize}`));
            notify("هذا الرقم مسجل من قبل", "warn");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.responseMessage === "Great, employee updated successfully"
          ) {
            dispatch(GetAllEmployeeAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, employee deleted successfully"
          ) {
            dispatch(GetAllEmployeeAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode === 500) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("يجب حذف جميع العمليات المرتبطة بهذا الموظف", "error");
        } else {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    أسم الموظف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                value={Name}
                onChange={(e) => setName(e.target.value)}
                //   className="ww"
              />
            </div>

            <div className="inp-container">
              <Autocomplete
                value={DepartmentId}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setDepartmentId({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setDepartmentId({
                      name: newValue.inputValue,
                    });
                  } else {
                    setDepartmentId(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={Array.isArray(ALLDepartment) ? ALLDepartment : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        الإدارة
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowManage}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={JopName}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setJopName({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setJopName({
                      name: newValue.inputValue,
                    });
                  } else {
                    setJopName(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={Array.isArray(ALLNameJop) ? ALLNameJop : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        المسمى الوظيفي
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowNameJop}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    صلاحيات
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  value={Roles}
                  onChange={(e) => setRoles(e.target.value)}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      صلاحيات
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }>
                  <MenuItem value={6}>صلاحيات كاملة</MenuItem>
                  <MenuItem value={5}>حضور وانصراف</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 15 }}
                type="number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    رقم الهاتف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            {Eye ? null : (
              <>
                <div className="inp-container ">
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        كلمة المرور
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    inputProps={{ maxLength: 120 }}
                    variant="outlined"
                    value={passwordInput}
                    onChange={(e) => setPasswordInput(e.target.value)}
                    type={Passwordp}
                  />

                  <button className="btn btn-primary e" onClick={togglep}>
                    {Passwordp === "password" ? (
                      <svg
                        width="20"
                        height="17"
                        fill="currentColor"
                        className="bi bi-eye-slash-fill"
                        viewBox="0 0 16 16">
                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                      </svg>
                    ) : (
                      <svg
                        width="20"
                        height="17"
                        fill="currentColor"
                        className="bi bi-eye-fill"
                        viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                      </svg>
                    )}
                  </button>
                </div>
                <div className="inp-container ">
                  {" "}
                  <TextField
                    inputProps={{ maxLength: 120 }}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        تأكيد كلمة المرور
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    onChange={(e) => setpasswordconfirmInput(e.target.value)}
                    type={Passwordc}
                    value={passwordconfirmInput}
                  />
                  <button className="btn btn-primary c" onClick={togglec}>
                    {Passwordc === "password" ? (
                      <svg
                        width="20"
                        height="17"
                        fill="currentColor"
                        className="bi bi-eye-slash-fill"
                        viewBox="0 0 16 16">
                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                      </svg>
                    ) : (
                      <svg
                        width="20"
                        height="17"
                        fill="currentColor"
                        className="bi bi-eye-fill"
                        viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                      </svg>
                    )}
                  </button>
                </div>
              </>
            )}

            <div className="inp-container">
              <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-chip-label">
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    ايام العمل الأسبوعية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-multiple-chip-label"
                  id="demo-multiple-chip"
                  multiple
                  value={WorkingDays}
                  onChange={handleChange}
                  input={
                    <OutlinedInput
                      id="select-multiple-chip"
                      label={
                        <Typography
                          sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                          ايام العمل الأسبوعية
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                    />
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}>
                  {namess.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      style={getStyles(name, WorkingDays, theme)}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="inp-container clock">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["TimePicker"]}>
                  <TimePicker
                    label={
                      "حضور"
                      // <Typography
                      //   sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      //   <span style={{ color: "red", fontSize: "21px" }}>
                      //     *
                      //   </span>
                      // </Typography>
                    }
                    value={Presence}
                    onChange={(newValue) => setPresence(newValue)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div className="inp-container clock">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["TimePicker"]}>
                  <TimePicker
                    label={
                      "انصراف"
                      // <Typography
                      //   sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      //   <span style={{ color: "red", fontSize: "21px" }}>
                      //     *
                      //   </span>
                      // </Typography>
                    }
                    value={Departure}
                    onChange={(newValue) => setDeparture(newValue)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  نوع العمل
                  {/* <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography> */}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={JopType}
                  label={
                    " نوع العمل"
                    // <Typography
                    //   sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    //   <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    // </Typography>
                  }
                  onChange={(e) => setJopType(e.target.value)}>
                  <MenuItem value={"بالشهر"}>بالشهر</MenuItem>
                  <MenuItem value={"بالأسبوع"}>بالأسبوع</MenuItem>
                  <MenuItem value={"باليوم"}>باليوم</MenuItem>
                  <MenuItem value={"بالساعة"}>بالساعة</MenuItem>
                  <MenuItem value={"حسب الأتفاق"}>حسب الأتفاق</MenuItem>
                </Select>
              </FormControl>
            </div>
            {JopType === "بالشهر" ? (
              <>
                <div className="inp-container">
                  <TextField
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    value={Insurance}
                    onChange={(e) => setInsurance(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        تأمينات شهرية
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    //   className="ww"
                  />
                </div>
                <div className="inp-container">
                  <TextField
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    value={Tax}
                    onChange={(e) => setTax(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        ضرائب شهرية
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    //   className="ww"
                  />
                </div>
              </>
            ) : null}
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 15 }}
                type="number"
                value={Salary}
                onChange={(e) => setSalary(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    قيمة المرتب
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>

            <div className="inp-container">
              <TextField
                label="أرشيف المستندات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                //   className="ww"
                onChange={(e) => setNote(e.target.value)}
                value={Note}
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {Filee && Filee.length > 0 && isEdit === false
                ? Filee.map((f, index) => (
                    <div className="fi" key={index}>
                      <a
                        href={
                          Array.isArray(FileeBase64)
                            ? FileeBase64[index]
                            : FileeBase64 || ""
                        }
                        target="_blank"
                        download={f.name}>
                        {f.name ? (
                          f.name
                        ) : (
                          <i
                            className="fa-solid fa-paperclip"
                            style={{ color: "#1866ec" }}></i>
                        )}
                      </a>
                      <div style={{ display: "block" }}>Attach File</div>
                      <button
                        style={{ background: "transparent" }}
                        className="buttonadd d">
                        <i
                          onClick={() => deleteFile(index)} // Pass the index here
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </button>
                    </div>
                  ))
                : null}
              {Filee && Filee.length > 0 && isEdit === true
                ? Filee.map((f, index) => (
                    <div className="fi" key={index}>
                      <a
                        href={f.fileUrl}
                        target="_blank"
                        download={f.uploadedFileName}
                        className="mt-3">
                        {f.uploadedFileName}

                        {/* {f.uploadedFileName ? (
                          f.uploadedFileName
                        ) : (
                          <i
                            className="fa-solid fa-paperclip"
                            style={{ color: "#1866ec" }}></i>
                        )} */}
                      </a>
                      {/* <div style={{ display: "block" }}>
                        {f.uploadedFileName}
                      </div> */}
                      <button
                        style={{ background: "transparent" }}
                        className="buttonadd d">
                        <i
                          onClick={() => deleteFile(index)} // Pass the index here
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </button>
                    </div>
                  ))
                : null}
            </div>
            {isEdit ? (
              <div className="inp-container input-check">
                إيقاف
                <input
                  type="checkbox"
                  value={Active}
                  checked={!Active}
                  onChange={(e) => setActive(!e.target.checked)}
                />
              </div>
            ) : null}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            {/* <div className="inp-container input-check">
              الأرشيف
              <input
                type="checkbox"
                // value={ShowArchiv}
                // onChange={(e) => setShowArchiv(e.target.checked)}
              />
            </div> */}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
          الاسم <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الإدارة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                 الوظيفة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الصلاحية <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                 الهاتف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                حضور <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                انصراف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                أيام العمل الأسبوعية{" "}
                <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                نوع العمل <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                 المرتب <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="export-only-column">
                تأمينات شهرية <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="export-only-column">
                ضرائب شهرية <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                الحالة  <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{item.name}</td>
                      <td>{item.department}</td>
                      <td>{item.jopTitle}</td>
                      <td>
                        {item.roleName === "Responsible"
                          ? "صلاحيات كاملة"
                          : "حضور وانصراف"}
                      </td>
                      <td>{item.phoneNumber}</td>
                      <td>{formatDisplayTime(item.presence)}</td>
                      <td>{formatDisplayTime(item.departure)}</td>
                      <td>{item.workingDays}</td>
                      <td>{item.jopType || ""}</td>
                      <td>{item.salary ?? ""}</td>
                      <td className="export-only-column">
                        {item.jopType === "بالشهر" ? (item.insurance ?? "") : ""}
                      </td>
                      <td className="export-only-column">
                        {item.jopType === "بالشهر" ? (item.tax ?? "") : ""}
                      </td>
                      <td>{item.isAccountActive ? "نشط" : "غير نشط"}</td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        {/* <button className="buttonadd" onClick={handleShowexport}>
          تصدير
        </button> */}
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        {/* <Pagination
          onPress={onPress}
          // PageSize={PageSize}
          PageCount={ALL ? ALL.totalCount : null} 
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        /> */}
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <Modal
        show={showManage}
        onHide={handleCloseManage}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>الإدارة</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Namemanage />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseManage}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showNameJop}
        onHide={handleCloseNameJop}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>المسمى الوظيفي</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <NameJob />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseNameJop}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <FormPrintView
        ref={myDivRefWorkcom}
        title="بيانات الموظف"
        fields={[
          { label: "أسم الموظف", value: formatPrintValue(Name) },
          { label: "الإدارة", value: formatPrintValue(DepartmentId) },
          { label: "المسمى الوظيفي", value: formatPrintValue(JopName) },
          { label: "صلاحيات", value: getRoleLabel(Roles) },
          { label: "رقم الهاتف", value: formatPrintValue(Phone) },
          {
            label: "ايام العمل الأسبوعية",
            value: Array.isArray(WorkingDays)
              ? WorkingDays.join("، ")
              : formatPrintValue(WorkingDays),
          },
          { label: "حضور", value: formatPrintTime(Presence) },
          { label: "انصراف", value: formatPrintTime(Departure) },
          { label: "نوع العمل", value: formatPrintValue(JopType) },
          ...(JopType === "بالشهر"
            ? [
                { label: "تأمينات شهرية", value: formatPrintValue(Insurance) },
                { label: "ضرائب شهرية", value: formatPrintValue(Tax) },
              ]
            : []),
          { label: "قيمة المرتب", value: formatPrintValue(Salary) },
          { label: "أرشيف المستندات", value: formatPrintValue(Note) },
          { label: "حالة الحساب", value: Active ? "نشط" : "غير نشط" },
        ]}
      />
    </>
  );
};
export default Enter;
